import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AddressEditPage } from './address-edit';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
	declarations: [
		AddressEditPage,
	],
	imports: [
		ComponentsModule,
		IonicPageModule.forChild(AddressEditPage),
	],
})
export class AddressEditPageModule {}



// WEBPACK FOOTER //
// ./src/pages/address-edit/address-edit.module.ts